import Cookies from 'js-cookie'
import { purgeStoredState } from 'redux-persist'
import { mainPersistConfig } from 'store/configureStore'
import history from 'utils/history'
import config from 'app/config'
import Browser from 'utils/Browser'
import API from 'utils/API'
import {
  AUTHENTICATE_USER_REQUEST,
  AUTHENTICATE_USER_SUCCESS,
  AUTHENTICATE_USER_FAILURE,
  UPDATE_AUTH_CURRENT_USER,
} from 'constants/ActionTypes'
import { updateSiteConfiguration } from './Site'


export const authenticateUserRequest = () => ({
  type: AUTHENTICATE_USER_REQUEST,
})

export const authenticateUserSuccess = data => ({
  type: AUTHENTICATE_USER_SUCCESS,
  currentUser: data,
})

export const authenticateUserFailure = errorMessage => ({
  type: AUTHENTICATE_USER_FAILURE,
  errorMessage,
})

export const updateAuthCurrentUser = currentUser => ({
  type: UPDATE_AUTH_CURRENT_USER,
  currentUser,
})

export const removeToken = () => {
  Cookies.remove(config.auth_cookie_name, { path: '' })
}

export const redirectToLogin = () => (
  Browser.setWindowHref('/login')
)

export const getAccessToken = () => (
  Cookies.get(config.auth_cookie_name)
)

export const loginUser = data => (
  (dispatch) => {
    dispatch(authenticateUserSuccess(data))
    Cookies.set(config.auth_cookie_name, data.token, {
      path: '',
      sameSite: 'strict',
      secure: true
    })
    dispatch(updateSiteConfiguration('activePage', 'dashboard'))

    Browser.setWindowHref('/dashboard')
  }
)

export const authenticateByCredentials = params => (
  (dispatch) => {
    dispatch(authenticateUserRequest())

    const loginAdmin = new Promise((resolve, reject) => {
      API.post(
        '/dashboard/auth/login',
        params,
        { headers: { Authorization: `Bearer ${config.api_key}` } },
      ).then((response) => {
        const { data } = response
        if (data.message === 'OK') {
          dispatch(loginUser(data.data))
          resolve(data.message)
        }
        // if (meta.status) {
        //   // dispatch(loginUser(data))
        //   // resolve(meta.status)
        // } else {
        //   // dispatch(updateAuthCurrentUser(null))
        //   // dispatch(authenticateUserFailure(response.data.meta.message))
        // }
      }).catch((err) => {
        if (err.response && err.response.data) {
          // dispatch(authenticateUserFailure(err.response.data.meta.message)) // eslint-disable-line no-console
          reject(err.response.data.message)
        } else {
          // dispatch(authenticateUserFailure(err.message)) // eslint-disable-line no-console
          reject(err.message)
        }
      })
    })

    return loginAdmin
  }
)

export const forgotPassword = payload => (
  () => new Promise((resolve, reject) => (
    API.post(
      '/dashboard/user/forgot-password',
      payload,
      { headers: { Authorization: `Bearer ${config.api_key}` } },
    ).then(
      (response) => {
        const { data } = response;
        if (data.message === 'OK') {
          resolve(data)
        } else {
          reject(data.message)
        }
      }
    ).catch((err) => {
      if (err.response && err.response.data) {
        reject(err.response.data.message)
      } else {
        reject(err.response.data.message)
      }
    })
  ))
)

export const resetPassword = payload => (
  () => new Promise((resolve, reject) => (
    API.post(
      '/password/reset',
      payload,
      { headers: { Authorization: `Bearer ${config.api_key}` } },
    ).then(
      (response) => {
        const { data } = response.data
        if (data.message === 'OK') {
          resolve(data)
        } else {
          reject(data.message)
        }
      },
    ).catch((err) => {
      if (err.response && err.response.data) {
        reject(err.response.data)
      } else {
        reject(err.message)
      }
    })
  ))
)

export const authenticateByToken = () => (
  (dispatch) => {
    const accessToken = Cookies.get(config.auth_cookie_name)
    if (!accessToken || accessToken === 'undefined') {
      dispatch(authenticateUserFailure())
      redirectToLogin()
    }
  }
)

export const clearCurrentUser = () => (
  () => (
    purgeStoredState(mainPersistConfig).then(() => {
      removeToken()
      Browser.setWindowHref('/')
    })
  )
)
